import { render, staticRenderFns } from "./DemographicConfirmation.vue?vue&type=template&id=9153b394&scoped=true"
import script from "./DemographicConfirmation.vue?vue&type=script&lang=ts"
export * from "./DemographicConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./DemographicConfirmation.vue?vue&type=style&index=0&id=9153b394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9153b394",
  null
  
)

export default component.exports